var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopWithOutClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 72,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.771 57.9585H98.0833V8.91674C98.0833 3.99912 94.0843 0 89.1665 0H17.8333C12.9157 0 8.91653 3.99892 8.91653 8.91674V57.9585H2.22903C0.997065 57.9585 0 58.9553 0 60.1875V62.4167C0 67.3343 3.99892 71.3335 8.91674 71.3335H98.0835C103.001 71.3335 107 67.3343 107 62.4167V60.1875C107 58.9553 106.003 57.9585 104.771 57.9585ZM13.375 8.91674C13.375 6.45908 15.3756 4.45847 17.8333 4.45847H89.1665C91.6242 4.45847 93.6248 6.45908 93.6248 8.91674V57.9585H64.6458H42.3542H13.375V8.91674ZM98.0833 66.875H8.91674C6.45908 66.875 4.45847 64.8744 4.45847 62.4167H11.146H41.4312L43.0073 63.9929C43.4253 64.4109 43.9912 64.646 44.5835 64.646H62.4167C63.0088 64.646 63.5749 64.4109 63.9929 63.9929L65.5688 62.4167H95.8542H102.542C102.542 64.8744 100.541 66.875 98.0833 66.875Z",
    fill: "#00A094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopWithOutClock);
export default __webpack_public_path__ + "static/media/laptopWithOutClock.ec237ce79e5f307793fabf1d1e5c5eca.svg";
export { ForwardRef as ReactComponent };